import { createRjf01Behaviors } from './rjf01'
import { createRjf02Behaviors } from './rjf02'
import { createRjf03Behaviors } from './rjf03'
import { createRjf04Behaviors } from './rjf04'
import { createRjf05Behaviors } from './rjf05'
import { createRjf06Behaviors } from './rjf06'
import { createRjf07Behaviors } from './rjf07'
import { createRjf08Behaviors } from './rjf08'
import { createRjf09Behaviors } from './rjf09'
import { createRjf10Behaviors } from './rjf10'
import { createRjf11Behaviors } from './rjf11'
import { createRjf12Behaviors } from './rjf12'
import { createRjs01Behaviors } from './rjs01'
import { createRjs02Behaviors } from './rjs02'
import { createRjs03Behaviors } from './rjs03'
import { createRjs04Behaviors } from './rjs04'
import { createRjs05Behaviors } from './rjs05'
import { createRjs06Behaviors } from './rjs06'
import { createRjs07Behaviors } from './rjs07'
import { createRjs08Behaviors } from './rjs08'
import { createRjs09Behaviors } from './rjs09'
import { createRjs10Behaviors } from './rjs10'
import { createRjs11Behaviors } from './rjs11'
import { createRjs12Behaviors } from './rjs12'
import { MissionBehaviorsFactory } from './types'

export type {
  BehaviorContext,
  BehaviorHandler,
  HudStyle,
  MissionBehaviors,
  MissionBehaviorsFactory,
} from './types'

/**
 * ミッション ID → 環境ビヘイビアのファクトリの登録表。
 * ID は表記揺れ（'RJF01' と 'RJF_01'）を吸収するため、正規化キー（'_' 除去・大文字）で持つ。
 */
const FACTORY_BY_NORMALIZED_ID: Readonly<
  Record<string, MissionBehaviorsFactory>
> = {
  RJF01: createRjf01Behaviors,
  RJF02: createRjf02Behaviors,
  RJF03: createRjf03Behaviors,
  RJF04: createRjf04Behaviors,
  RJF05: createRjf05Behaviors,
  RJF06: createRjf06Behaviors,
  RJF07: createRjf07Behaviors,
  RJF08: createRjf08Behaviors,
  RJF09: createRjf09Behaviors,
  RJF10: createRjf10Behaviors,
  RJF11: createRjf11Behaviors,
  RJF12: createRjf12Behaviors,
  RJS01: createRjs01Behaviors,
  RJS02: createRjs02Behaviors,
  RJS03: createRjs03Behaviors,
  RJS04: createRjs04Behaviors,
  RJS05: createRjs05Behaviors,
  RJS06: createRjs06Behaviors,
  RJS07: createRjs07Behaviors,
  RJS08: createRjs08Behaviors,
  RJS09: createRjs09Behaviors,
  RJS10: createRjs10Behaviors,
  RJS11: createRjs11Behaviors,
  RJS12: createRjs12Behaviors,
}

import { SceneDescriptor } from '../types'
import { composeBehaviorFactories } from './composeBehaviors'
import { scriptBehaviorsForScene } from './scriptBindings'
import { tagBehaviorsForScene } from './tagBindings'

/**
 * シーン記述から環境ビヘイビアのファクトリを解決する。
 * ミッション別 TS 実装、CollectionService タグ由来の汎用ビヘイビア、
 * rbxl Script 由来の安全な既知パターンを合成する。
 * どれも無ければ undefined（ビヘイビアなしでプレビューを動かす）。
 */
export const behaviorsForScene = (
  descriptor: SceneDescriptor,
): MissionBehaviorsFactory | undefined =>
  composeBehaviorFactories([
    behaviorsForMission(descriptor.missionId),
    tagBehaviorsForScene(descriptor),
    scriptBehaviorsForScene(descriptor),
  ])

/** ミッション ID を比較用に正規化する（'_' を除去し大文字化）。 */
const normalizeMissionId = (missionId: string): string =>
  missionId.replace(/_/g, '').toUpperCase()

/**
 * ミッション ID に対応する環境ビヘイビアのファクトリを返す。
 * 未登録・未指定なら undefined（ビヘイビアなしでプレビューを動かす）。
 *
 * @param missionId ミッション ID。'RJF01' と 'RJF_01' の両表記を許容する。
 */
export const behaviorsForMission = (
  missionId: string | undefined,
): MissionBehaviorsFactory | undefined => {
  if (!missionId) {
    return undefined
  }
  return FACTORY_BY_NORMALIZED_ID[normalizeMissionId(missionId)]
}
